import { createFeature } from '@ngrx/store';

import { notificationReducer } from './notification.reducer';

export const notificationFeatureKey = 'notification';

export const notificationFeature = createFeature({
  name: notificationFeatureKey,
  reducer: notificationReducer,
});
